import { Button, Divider } from 'antd';
import React, { useEffect, useState } from "react";
import common_axios from "./../commonAxios";
import "./UserAdmin.css"

const UserAdmin = () => {

    const [ingredients, setIngredients] = useState([]);
    const [selectedIngredients, setSelectedIngredients] = useState([]);
    const [unselectedIngredients, setUnselectedIngredients] = useState([]);

    useEffect(() => {
        loadData();
    }, []);

    const loadData = () => {
        common_axios.get(`${process.env.REACT_APP_API_URL}/IngredientToUser/` + localStorage.getItem("userid") + `/allInfo`)
            .then(response => {
                setIngredients(response.data.allIngredients);
                setUnselectedIngredients(response.data.notSelectedIngredients);
                setSelectedIngredients(response.data.selectedIngredients);
            })
            .catch(error => {
                console.error(error);
            });
    }

    const postIngredientToUser = (postIngredientName) => {
        common_axios.post(`${process.env.REACT_APP_API_URL}/IngredientToUser/byName`, {
            ingredientName: postIngredientName,
            userId: localStorage.getItem("userid"),
            amount: 0
        })
            .then(() => {
                loadData();
            })
            .catch(error => {
                console.error(error);
            });
    }

    const deleteIngredient = (postIngredientName) => {
        common_axios.delete(`${process.env.REACT_APP_API_URL}/IngredientToUser/` + localStorage.getItem("userid") + `/` + postIngredientName)
            .then(() => {
                loadData();
            })
            .catch(error => {
                console.error(error);
            });
    }

    return (
        <div className='wrapper'>
            <Divider className='titleReadable' style={{ marginBottom: "20px" }}>Deine getrackten Ingredients</Divider>
            {selectedIngredients.map(item => (
                <div key={item.id} className='itemIngredient'>{item.name} <Button className="buttonIngredientDelete" onClick={() => deleteIngredient(item.name)}>X</Button></div>
            ))}

            <Divider className='titleReadable' style={{ marginBottom: "20px" }}>Neue Ingredients tracken</Divider>
            {unselectedIngredients.map(item => (
                <div key={item.id} className='itemIngredient'>{item.name} <Button className="buttonIngredientAdd" onClick={() => postIngredientToUser(item.name)}>+</Button></div>
            ))}
        </div>
    );
};

export default UserAdmin;